import { render, staticRenderFns } from "./AttendanceForm.vue?vue&type=template&id=40227046"
import script from "./AttendanceForm.vue?vue&type=script&lang=js"
export * from "./AttendanceForm.vue?vue&type=script&lang=js"
import style0 from "./AttendanceForm.vue?vue&type=style&index=0&id=40227046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports